import { render, staticRenderFns } from "./PlanDetailsCard.vue?vue&type=template&id=84710fe6&scoped=true&"
import script from "./PlanDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./PlanDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanDetailsCard.vue?vue&type=style&index=0&id=84710fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84710fe6",
  null
  
)

export default component.exports